// Shared screen frame: top bar with back navigation and title.
import type { ComponentChildren } from 'preact';
import { useHashLocation } from 'wouter-preact/use-hash-location';
import './screens.css';

export function Screen(p: { title: string; children: ComponentChildren; back?: string; class?: string; actions?: ComponentChildren }) {
  const [, navigate] = useHashLocation();
  return (
    <div class={`screen ${p.class ?? ''}`}>
      <header class="topbar">
        <button type="button" class="icon-btn" aria-label="Back" onClick={() => navigate(p.back ?? '/')}>
          ←
        </button>
        <h1 class="topbar-title">{p.title}</h1>
        <div class="topbar-actions">{p.actions}</div>
      </header>
      <main id="main" class="screen-body">
        {p.children}
      </main>
    </div>
  );
}

export function useNavigate(): (to: string) => void {
  const [, navigate] = useHashLocation();
  return navigate;
}
